import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrl = "/api/v2/email/leadcapture";

export interface LeadCaptureModel extends BaseModel {
    emailAddress: string;
    companyName: string;
    emailTo: string;
    fullName: string;
    zipCode: string;
    industry: string;
    OptToSomethingKeyValPair: Record<string, string>;
}

export interface ShareLCTParameter {
    emailAddress: string;
    companyName: string;
    emailTo: string;
    fullName: string;
    zipCode: string;
    industry: string;
    OptToSomethingKeyValPair: Record<string, string>;
    onSuccess?: () => void;
}

export interface ShareLCTApiParameter extends ApiParameter {
    leadCaptureModel: LeadCaptureModel;
}

export function shareLCTService(parameter: ShareLCTApiParameter) {
    return post<LeadCaptureModel>(`${emailsUrl}`, parameter.leadCaptureModel);
}
